/**
 * AUTHOR: raphael-leger
 * SOURCE: https://gist.github.com/raphael-leger/4d703dea6c845788ff9eb36142374bdb
 */

import { lazy } from 'react';

const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('wg-page-has-been-force-refreshed') ||
        'false',
    );

    try {
      const component = await componentImport();

      window.localStorage.setItem('wg-page-has-been-force-refreshed', 'false');

      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem('wg-page-has-been-force-refreshed', 'true');
        return window.location.reload();
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });

export default lazyWithRetry;
